module.exports = __webpack_public_path__ + "img/Flag_of_Vanuatu.f3e61ec9.svg";